(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[193],{

/***/ 110:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avif-speed-quality-benchmark",
      function () {
        return __webpack_require__(2470);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9938:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/a.cc1f7625.png","height":768,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAKlBMVEWCiYOOlo1hameMiYB2f35gYWSZpJuqq5avsaGJiW+BdFlCU2WBfkrKyaffrJL1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVR4nCXExw0AIAwEwT0HTOy/XYSYxxA80l8SzXMFzeceRK9TpDtglmYXCvsAkNZFaVYAAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 2332:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/b.3adc7de2.jpg","height":768,"width":512,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAUDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAL/xAAbEAACAgMBAAAAAAAAAAAAAAAAAQISAwQycf/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AueTDN2WzrqD5i7WXoABL/9k=","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 1804:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/d.86a3664a.png","height":768,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAANlBMVEWMlIyrq5hZYWKBd1F1fX2Wn5eEhICAiIOEioRgZ2SKiX18gn5jbmyPjIOIiG5CUWRpX2PIyaciQjiRAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAL0lEQVR4nBXBhxGAMAwAsXfimgr7L8shoZE5gYzA+Nl+rmLe+0FFXqGN4U6tVvUBFeAA+fH5eyoAAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 2763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 72px;\n  @media screen and (max-width: 1439px) and (min-width: 905px) {\n    height: 60px;\n  }\n  @media screen and (max-width: 904px) and (min-width: 600px) {\n    height: 52px;\n  }\n  @media screen and (max-width: 599px) {\n    height: 44px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var HeaderSpaceWrapper = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HeaderSpaceWrapperContainer, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderSpaceWrapper);
var HeaderSpaceWrapperContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "HeaderSpaceWrapper__HeaderSpaceWrapperContainer",
    componentId: "sc-132c2234-0"
})(_templateObject());


/***/ }),

/***/ 1875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ AVIFHeadTextComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9059);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  padding: 32px 0 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var AVIFHeadTextComponent = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(global_styles__WEBPACK_IMPORTED_MODULE_1__/* .AVIFHeadText */ .cf).withConfig({
    displayName: "AVIFCommonComponents__AVIFHeadTextComponent",
    componentId: "sc-4646caf5-0"
})(_templateObject());


/***/ }),

/***/ 4233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var components_Common_CommonWrappers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5564);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid #f2f2f2;\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 12px;\n  width: 100%;\n  & + & {\n    margin-left: 18px;\n  }\n\n  .top-area {\n    width: 100%;\n    padding-top: ",
        ";\n    position: relative;\n  }\n  .bottom-area {\n    padding: 8px;\n  }\n\n  .o-c-w {\n    font-weight: 500;\n  }\n  .s-c-w {\n    font-weight: 700;\n  }\n  .upper-w {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n  }\n  .below-w {\n    margin-top: 12px;\n    font-weight: 500;\n  }\n\n  @media screen and (max-width: 904px) {\n    margin: 16px 0;\n  }\n\n  @media screen and (max-width: 904px) {\n    margin: 8px 0;\n    & + & {\n      margin-left: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var AVIFSpeedQualityTestImageArea = function(param) {
    var src = param.src, imgOgCompText = param.imgOgCompText, sizeAndContainerText = param.sizeAndContainerText, _scoreText = param.scoreText, scoreText = _scoreText === void 0 ? "" : _scoreText, paddingTopPercentage = param.paddingTopPercentage, _priority = param.priority, priority = _priority === void 0 ? false : _priority;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AVIFSpeedQualityTestImageAreaContainer, {
        paddingTopPercentage: paddingTopPercentage,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "top-area",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Common_CommonWrappers__WEBPACK_IMPORTED_MODULE_2__/* .ImgBackgroundWrapper */ .Yo, {
                    isNormalUse: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                        src: src,
                        alt: "",
                        objectFit: "cover",
                        layout: "fill",
                        priority: priority
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bottom-area",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "upper-w",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                className: "o-c-w",
                                children: imgOgCompText
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                className: "s-c-w",
                                children: sizeAndContainerText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "below-w",
                        children: scoreText
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AVIFSpeedQualityTestImageArea);
var AVIFSpeedQualityTestImageAreaContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AVIFSpeedQualityTestImageArea__AVIFSpeedQualityTestImageAreaContainer",
    componentId: "sc-aa888a9-0"
})(_templateObject(), function(param) {
    var paddingTopPercentage = param.paddingTopPercentage;
    return paddingTopPercentage;
});


/***/ }),

/***/ 1222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ AVIFSpeedQualityImgs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5505);
/* harmony import */ var _AVIFCommonComponents__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1875);
/* harmony import */ var assets_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1089);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9059);
/* harmony import */ var _AVIFSpeedQualityTestImageArea__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4233);
/* harmony import */ var public_asset_product_pulsar_05_AVIF_yacht_a_png__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9938);
/* harmony import */ var public_asset_product_pulsar_05_AVIF_yacht_b_jpg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2332);
/* harmony import */ var public_asset_product_pulsar_05_AVIF_yacht_d_png__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1804);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_10__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-top: 48px;\n  .read-more-link {\n    display: flex;\n    height: 64px;\n    background: #f2f2f2;\n    align-items: center;\n    margin-top: 24px;\n    border-radius: 9999px;\n    font-family: 'Noto Sans KR', sans-serif;\n    font-size: 17px;\n    font-weight: 700;\n    color: ",
        ";\n    padding-left: 32px;\n  }\n  .read-more-link:hover .svg-t {\n    text-decoration: underline;\n  }\n  .svg-t,\n  .svg-w,\n  .svg-g-t {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .svg-w {\n    width: 76px;\n    height: 32px;\n    transform: rotate(180deg);\n  }\n  .svg-g-t {\n    width: 66px;\n    height: 30px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  padding: 12px;\n  @media screen and (max-width: 904px) {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var AvifSQTestCondition = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AvifSQTestConditionContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AVIFCommonComponents__WEBPACK_IMPORTED_MODULE_3__/* .AVIFHeadTextComponent */ ._, {
                children: "AVIF Speed/Quality Benchmark"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AVIFSpeedQualityImgs, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_10___default()), {
                href: "/avif-speed-quality-benchmark",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                    className: "read-more-link",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            className: "svg-t",
                            children: "Read more in details"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            className: "svg-g-t",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_4__/* .GoToIcon */ .A5, {
                                size: "18"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AvifSQTestCondition);
var AvifSQTestConditionContainer = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AvifSQTestCondition__AvifSQTestConditionContainer",
    componentId: "sc-5d74bc16-0"
})(_templateObject(), global_styles__WEBPACK_IMPORTED_MODULE_5__.BB);
var AVIFSpeedQualityImgs = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AVIFSpeedQualityImgsContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AVIFSpeedQualityTestImageArea__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                src: public_asset_product_pulsar_05_AVIF_yacht_a_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"].src */ .Z.src,
                imgOgCompText: "(a) original",
                sizeAndContainerText: "PNG / 582.9kb",
                paddingTopPercentage: "150%",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AVIFSpeedQualityTestImageArea__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                src: public_asset_product_pulsar_05_AVIF_yacht_b_jpg__WEBPACK_IMPORTED_MODULE_8__/* ["default"].src */ .Z.src,
                imgOgCompText: "(b) compressed",
                sizeAndContainerText: "jpeg / 16.2kb",
                scoreText: "psnr=34.19, ssim=0.914, vmaf=81.4",
                paddingTopPercentage: "150%",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AVIFSpeedQualityTestImageArea__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                src: public_asset_product_pulsar_05_AVIF_yacht_d_png__WEBPACK_IMPORTED_MODULE_9__/* ["default"].src */ .Z.src,
                imgOgCompText: "(d) compressed",
                sizeAndContainerText: "pulsar avif / 7.1kb",
                scoreText: "psnr=35.49, ssim=0.927, vmaf=77.6",
                paddingTopPercentage: "150%",
                priority: true
            })
        ]
    });
};
var AVIFSpeedQualityImgsContainer = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AvifSQTestCondition__AVIFSpeedQualityImgsContainer",
    componentId: "sc-5d74bc16-1"
})(_templateObject1());


/***/ }),

/***/ 8722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useRemoveScrollTop; }
/* harmony export */ });
/* harmony import */ var context_BlogContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var useRemoveScrollTop = function() {
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().asPath;
    var dispatch = (0,context_BlogContext__WEBPACK_IMPORTED_MODULE_0__/* .useBlogContext */ .F)().dispatch;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!asPath.includes("blog")) {
            dispatch({
                type: "change",
                newState: {
                    prevScrollTop: 0
                }
            });
        }
    }, [
        asPath,
        dispatch
    ]);
};


/***/ }),

/***/ 2470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AVIFSpeedQualityBenchmarkPageContainer": function() { return /* binding */ AVIFSpeedQualityBenchmarkPageContainer; },
  "default": function() { return /* binding */ avif_speed_quality_benchmark; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ./components/NewHeader/index.tsx + 11 modules
var NewHeader = __webpack_require__(1849);
// EXTERNAL MODULE: ./components/About/index.ts + 12 modules
var About = __webpack_require__(5710);
// EXTERNAL MODULE: ./components/Common/HeaderSpaceWrapper.tsx
var HeaderSpaceWrapper = __webpack_require__(2763);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(2587);
// EXTERNAL MODULE: ../../packages/global-styles/index.ts
var global_styles = __webpack_require__(9059);
// EXTERNAL MODULE: ./hooks/useRemoveScrollTop.ts
var useRemoveScrollTop = __webpack_require__(8722);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ./components/Product/Pulsar/AVIFDetailCodec.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Noto Sans KR', sans-serif;\n  color: #313131;\n  table {\n    border-collapse: collapse;\n    table-layout: fixed;\n    width: 100%;\n    text-align: left;\n  }\n  thead th {\n    background: #f2f2f2;\n    width: 33.33%;\n    padding: 10px 16px;\n  }\n  td {\n    padding: 10px 16px;\n    width: 33.33%;\n    word-break: break-word;\n  }\n  td p {\n    min-height: 80px;\n  }\n  tr {\n    border: 1px solid #d4d4d4;\n  }\n  th + th {\n    border-left: 1px solid #d4d4d4;\n  }\n  td + td {\n    border-left: 1px solid #d4d4d4;\n  }\n  ul {\n    padding-left: 28px;\n    list-style: disc;\n  }\n  table.t-f-th thead th:first-of-type {\n    background: transparent;\n  }\n  table.t-f-th tbody td:first-of-type {\n    text-align: left;\n  }\n  table.t-f-th tbody td {\n    text-align: right;\n  }\n\n  @media screen and (max-width: 599px) {\n    thead th,\n    td {\n      padding: 10px;\n    }\n    ul {\n      padding-left: 20px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 500;\n  /* margin: 0 0 24px; */\n  line-height: 210%;\n  /* display: inline-block; */\n\n  .under-l {\n    text-decoration: underline;\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 48px;\n  .command-area {\n    background: #f2f2f2;\n    display: flex;\n    flex-direction: column;\n    padding: 32px;\n    margin-bottom: 24px;\n  }\n  .c-t + .c-t {\n    margin-top: 15px;\n  }\n  .c-t-s-t {\n    color: #313131;\n  }\n\n  .c-t.c-t-s-t {\n    color: #4d4d4d;\n  }\n\n  .command-sub-area {\n    padding: 16px 32px;\n    border-top: 1px solid #b0b0b0;\n    border-bottom: 1px solid #b0b0b0;\n    margin-bottom: 24px;\n  }\n  .tt-w + .tt-w {\n    margin-top: 24px;\n  }\n  .tt-w {\n    color: #313131;\n  }\n  .tt-w-inner-w {\n    padding: 16px 32px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 24px;\n  display: block;\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 5px;\n  height: 5px;\n  background: #313131;\n  border-radius: 50%;\n  display: inline-block;\n  margin: 0 8px 2px 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var AVIFDetailCodec = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AVIFDetailCodecContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CodecDetailSubTitle, {
                children: "Codec"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                    as: "th",
                                    children: "Codec"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                    as: "th",
                                    children: "Code base"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                    as: "th",
                                    children: "Hash"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "libjpeg-turbo"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "a JPEG codec to accelerate libjpeg by 2-6x"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://github.com/libjpeg-turbo/libjpeg-turbo",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFStrongText, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "under-l",
                                                            children: "https://github.com/libjpeg-turbo/libjpeg-turbo"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "a01857cff6a2b7b3283ef1d0ecb6b01d06b597f8"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "avifenc"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://github.com/AOMediaCodec/libavif",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFStrongText, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "under-l",
                                                            children: "https://github.com/AOMediaCodec/libavif"
                                                        })
                                                    })
                                                }),
                                                " ",
                                                "v0.11.1",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "aom: v3.5.0"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "svt: v1.3.0"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "6ab53189045e7a6fe0bd93d14977b2a4f8efa5e9"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "pulsar-avif"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "BLUEDOT's FPGA-based AVIF encoder"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "5307f4605513110ad3c267fac6873e1deb913385"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CodecDetailSubTitle, {
                style: {
                    marginTop: "24px"
                },
                children: "Command line"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "command-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFCommandText */.FE, {
                        className: "c-t",
                        children: "libjpeg-turbo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* AVIFCommandSubText */.br, {
                        className: "c-t c-t-s-t",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FakeDisc, {}),
                            "./cjpeg -quality ${quality} -sample 2x2 -outfile ${output jpg} ${input ppm}"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFCommandText */.FE, {
                        className: "c-t",
                        children: "avifenc with AOM"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* AVIFCommandSubText */.br, {
                        className: "c-t c-t-s-t",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FakeDisc, {}),
                            "./avifenc ${input png} --min ${qp} --max ${qp} -y 420 -d 8 -j ${thread} -r l -c aom ${output avif}"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFCommandText */.FE, {
                        className: "c-t",
                        children: "avifenc with SVT"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* AVIFCommandSubText */.br, {
                        className: "c-t c-t-s-t",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FakeDisc, {}),
                            "./avifenc ${input png} --min ${qp} --max ${qp} -y 420 -d 8 -j ${thread} -r l -c svt ${output avif}"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFCommandText */.FE, {
                        className: "c-t",
                        children: "pulsar-avif"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* AVIFCommandSubText */.br, {
                        className: "c-t c-t-s-t",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FakeDisc, {}),
                            "./avif_sp_client -i ${input yuv} -o ${output avif} --width ${width} --height ${height} --enable-avif 1 --avif-seq 0 --fps 1 --frames 1 --qp ${qp}"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "command-sub-area",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                    children: "The test images are in the format of jpg. For the evaluation, we used decoded images of them. Therefore, the speed measured here does not include a time for decoding jpg and converting color space."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "test-imgs-area tt-w",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CodecDetailSubTitle, {
                        children: "Test Images"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tt-w-inner-w",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                                children: "https://drive.google.com/drive/folders/1VK12pBFnYJzJRD1k8uo38yammO-_XtkO"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* AVIFDefaultText */.oU, {
                                        as: "li",
                                        children: [
                                            "Kodak - 24 images, 768x512;",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://r0k.us/graphics/kodak/",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFStrongText, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "under-l",
                                                        children: "Kodak Lossless True Color Image Suite"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                                        as: "li",
                                        children: "CLIC - 303 images, 2048x1320; from workshop and challenges on learned image compression(CLIC)"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "qmace-area tt-w",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CodecDetailSubTitle, {
                        children: "Quality Metrics and Coding Efficiency"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tt-w-inner-w",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                                children: "BD-Rate for the following metrics:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                                        as: "li",
                                        children: "PSNR_Y"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                                        as: "li",
                                        children: "PSNR_AVG: (PSNR_Y * 4 + PSNR_U + PSNR_V) / 6"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                                        as: "li",
                                        children: "SSIM"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                                        as: "li",
                                        children: "VIF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                                children: "BD-Rate: G. Bjontegaard, Calculation of average PSNR differences between RD-curves (VCEG-M33)"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Pulsar_AVIFDetailCodec = (AVIFDetailCodec);
var AVIFDetailCommonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AVIFDetailCodec__AVIFDetailCommonContainer",
    componentId: "sc-c5064f2d-0"
})(_templateObject());
var AVIFStrongText = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* AVIFDefaultText */.oU).withConfig({
    displayName: "AVIFDetailCodec__AVIFStrongText",
    componentId: "sc-c5064f2d-1"
})(_templateObject1(), global_styles.SB);
var AVIFDetailCodecContainer = (0,styled_components_browser_esm/* default */.ZP)(AVIFDetailCommonContainer).withConfig({
    displayName: "AVIFDetailCodec__AVIFDetailCodecContainer",
    componentId: "sc-c5064f2d-2"
})(_templateObject2());
var CodecDetailSubTitle = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* AVIFSubHeadText */.IY).withConfig({
    displayName: "AVIFDetailCodec__CodecDetailSubTitle",
    componentId: "sc-c5064f2d-3"
})(_templateObject3(), global_styles/* GRAY30 */.zm);
var StyledTableHeaderText = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* AVIFTableHeaderText */.Cb).withConfig({
    displayName: "AVIFDetailCodec__StyledTableHeaderText",
    componentId: "sc-c5064f2d-4"
})(_templateObject4());
var StyledTableText = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* AVIFTableText */.so).withConfig({
    displayName: "AVIFDetailCodec__StyledTableText",
    componentId: "sc-c5064f2d-5"
})(_templateObject5());
var FakeDisc = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "AVIFDetailCodec__FakeDisc",
    componentId: "sc-c5064f2d-6"
})(_templateObject6());

// EXTERNAL MODULE: ./components/Product/Pulsar/AVIFCommonComponents.tsx
var AVIFCommonComponents = __webpack_require__(1875);
// EXTERNAL MODULE: ./components/Product/Pulsar/AVIFSpeedQualityTestImageArea.tsx
var AVIFSpeedQualityTestImageArea = __webpack_require__(4233);
;// CONCATENATED MODULE: ./public/asset/product/pulsar/05-AVIF/tree/a.png
/* harmony default export */ var a = ({"src":"/_next/static/media/a.658bd941.png","height":1289,"width":1999,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAOVBMVEVucGF0eWd2dWyPi3mXmJLAwMGNioJoaVyChX1cYVKvsKuEiYaAfXVRV0xITUNXYVl8cmSXkYijpaOYWfjbAAAACnRSTlP+/////Pj4/vv8JcjA8gAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC5JREFUeJwFwYcBACAIwLACKrjH/8ea0JpEQgavgx6vzOWmJps1x3XTTkke1MgfGcIBJvbRhxUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/05-AVIF/tree/b.jpg
/* harmony default export */ var b = ({"src":"/_next/static/media/b.eafd91fd.jpg","height":1289,"width":1999,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAL/xAAaEAACAwEBAAAAAAAAAAAAAAABAwACEQRh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAL/xAAVEQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEQMRAD8AkKa7sXzPfZl3XFbNzMJAIIHgORESYP/Z","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/05-AVIF/tree/c.png
/* harmony default export */ var c = ({"src":"/_next/static/media/c.cf21d7ec.png","height":1289,"width":1999,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAPFBMVEVoZ1u/v8CFh4BvdGOPjH+Bf3aBhn9aX1NwbWCXl5F5c2iur6p0d2tITEFRV0uQiHJ8eXRrb1uWkIeipKLP7rrfAAAACnRSTlP++P///Pz4/fz8+S4jZQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC9JREFUeJwFwYcBACAIwLAKKg7c//9qQu8q9ejmiRZvGHMgLboxZrosF2IlFcvhAx2tATsldg5IAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/05-AVIF/tree/d.png
/* harmony default export */ var d = ({"src":"/_next/static/media/d.843f90fb.png","height":1289,"width":1999,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAPFBMVEWDh4G/v8B3c2lcYVeXl5GLiH1bYExubl9paVx/fnVucmSurqp0eGVHTEGPiHKSj32WkIdSVU5QV0iipKJ0CFrpAAAACnRSTlP++P///Pz4/f39lzIisgAAAAlwSFlzAAALEwAACxMBAJqcGAAAADBJREFUeJwFwYECwBAIQMGnWEXG5v//1R1jJNUyOHQTceWb3mSlMv/Y+gq06mEP5QIc/AE0aYJFQAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./public/asset/product/pulsar/05-AVIF/yacht/a.png
var yacht_a = __webpack_require__(9938);
// EXTERNAL MODULE: ./public/asset/product/pulsar/05-AVIF/yacht/b.jpg
var yacht_b = __webpack_require__(2332);
;// CONCATENATED MODULE: ./public/asset/product/pulsar/05-AVIF/yacht/c.png
/* harmony default export */ var yacht_c = ({"src":"/_next/static/media/c.c47131da.png","height":768,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAM1BMVEWBiYNbYWOUnpSKh3R1fX2rq5mDgYCMlIxjZGWFiIBlbG2cpZuAc1pDUWSAfUqQi4PIyKdvF6v/AAAACXBIWXMAAAPoAAAD6AG1e1JrAAAALUlEQVR4nAXBiQEAIAjEsKrA4e/+05pgQCABVEmi3tzGjHUa5v6c0lsPcpTMDxOQAPEF4F18AAAAAElFTkSuQmCC","blurWidth":5,"blurHeight":8});
// EXTERNAL MODULE: ./public/asset/product/pulsar/05-AVIF/yacht/d.png
var yacht_d = __webpack_require__(1804);
;// CONCATENATED MODULE: ./components/Product/Pulsar/AVIFDetailExamples.tsx

function AVIFDetailExamples_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 24px;\n  .t-imgs-area,\n  .y-imgs-area {\n    display: flex;\n    padding: 0 24px;\n  }\n  .t-imgs-area + .t-imgs-area,\n  .y-imgs-area + .y-imgs-area {\n    margin-top: 24px;\n  }\n  @media screen and (max-width: 904px) {\n    .t-imgs-area,\n    .y-imgs-area {\n      flex-direction: column;\n    }\n\n    .t-imgs-area + .t-imgs-area,\n    .y-imgs-area + .y-imgs-area {\n      margin-top: 0;\n    }\n  }\n"
    ]);
    AVIFDetailExamples_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var AVIFDetailExamples = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AVIFDetailExamplesContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFCommonComponents/* AVIFHeadTextComponent */._, {
                children: "Examples"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                style: {
                    padding: "0 0 24px 0",
                    display: "inline-block"
                },
                children: "CLIC, 2048x1320, john-price-5258"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "t-imgs-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFSpeedQualityTestImageArea/* default */.Z, {
                        src: a.src,
                        imgOgCompText: "(a) original",
                        sizeAndContainerText: "png / 3,604kb",
                        paddingTopPercentage: "64.48%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFSpeedQualityTestImageArea/* default */.Z, {
                        src: b.src,
                        imgOgCompText: "(b) compressed",
                        sizeAndContainerText: "jpeg / 132kb",
                        paddingTopPercentage: "64.48%",
                        scoreText: "psnr=40.7dB, ssim=0.964, vmaf=89.96"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "t-imgs-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFSpeedQualityTestImageArea/* default */.Z, {
                        src: c.src,
                        imgOgCompText: "(c) compressed",
                        sizeAndContainerText: "aom avif / 66kb",
                        paddingTopPercentage: "64.48%",
                        scoreText: "psnr=41.93, ssim=0.973, vmaf=88.82"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFSpeedQualityTestImageArea/* default */.Z, {
                        src: d.src,
                        imgOgCompText: "(d) compressed",
                        sizeAndContainerText: "pulsar avif / 67kb",
                        paddingTopPercentage: "64.48%",
                        scoreText: "psnr=42.01, ssim=0.972, vmaf=88.62"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                style: {
                    padding: "24px 0",
                    display: "inline-block"
                },
                children: "Kodak, 512x768, kodim09"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "y-imgs-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFSpeedQualityTestImageArea/* default */.Z, {
                        src: yacht_a/* default.src */.Z.src,
                        imgOgCompText: "(a) original",
                        sizeAndContainerText: "png / 582.9kb",
                        paddingTopPercentage: "150%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFSpeedQualityTestImageArea/* default */.Z, {
                        src: yacht_b/* default.src */.Z.src,
                        imgOgCompText: "(b) compressed",
                        sizeAndContainerText: "jpeg / 16.2kb",
                        paddingTopPercentage: "150%",
                        scoreText: "psnr=34.19, ssim=0.914, vmaf=81.4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "y-imgs-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFSpeedQualityTestImageArea/* default */.Z, {
                        src: yacht_c.src,
                        imgOgCompText: "(c) compressed",
                        sizeAndContainerText: "aom avif / 6.2kb",
                        paddingTopPercentage: "150%",
                        scoreText: "psnr=34.99, ssim=0.923, vmaf=75.7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFSpeedQualityTestImageArea/* default */.Z, {
                        src: yacht_d/* default.src */.Z.src,
                        imgOgCompText: "(d) compressed",
                        sizeAndContainerText: "pulsar avif / 7.1kb",
                        paddingTopPercentage: "150%",
                        scoreText: "psnr=35.49, ssim=0.927, vmaf=77.6"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Pulsar_AVIFDetailExamples = (AVIFDetailExamples);
var AVIFDetailExamplesContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AVIFDetailExamples__AVIFDetailExamplesContainer",
    componentId: "sc-4ffeec6b-0"
})(AVIFDetailExamples_templateObject());

// EXTERNAL MODULE: ./components/Common/CommonWrappers.tsx
var CommonWrappers = __webpack_require__(5564);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/asset/product/pulsar/05-AVIF/xl-2.png
/* harmony default export */ var xl_2 = ({"src":"/_next/static/media/xl-2.20d5aa59.png","height":900,"width":1200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAMFBMVEX////j4+b3+Pv11rvk4+3IopjJnYrs2M3w8frk0cjNqI/IlX736+Ln6uzhvqnOsaHmVrVYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAL0lEQVR4nAXBhwEAIAzDMKeLDf9/i4R0dAxgu7s3w8aqWtmhzfkUBqMy7wZMEep8Gd0A88+eTPQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/05-AVIF/xl-3.png
/* harmony default export */ var xl_3 = ({"src":"/_next/static/media/xl-3.22457c08.png","height":900,"width":1200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAJ1BMVEX////k4+fm6O7ImYb117zo1Mr49vfNp5H4+vz37ejKoZDjzcPSu7VFGmz8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAL0lEQVR4nBXKuREAIAwEsT2/YOi/XoZMgZBMVgA7IqJgHR/3DWT3tfXh0/lPSTJ4EwwArrCsWAwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./components/Product/Pulsar/AVIFDetailResults.tsx

function AVIFDetailResults_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .img-w {\n    position: relative;\n    padding-top: 75%;\n  }\n"
    ]);
    AVIFDetailResults_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AVIFDetailResults_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #313131;\n  display: block;\n  padding: 24px 0;\n"
    ]);
    AVIFDetailResults_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var AVIFDetailResults = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AVIFDetailResultsContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFCommonComponents/* AVIFHeadTextComponent */._, {
                children: "Results"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CodecDetailSubTitle, {
                children: "Coding Efficiency"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "img-w",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                    isNormalUse: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: xl_2.src,
                        alt: "",
                        objectFit: "cover",
                        layout: "fill"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultsStyledDefaultText, {
                children: "Interpretation: For example, when avifenc(aom) has the same PSNR_Y score as libjpeg-turbo, avifienc(aom)'s file size is 56.21% smaller than libjpeg-turbo."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "img-w",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                    isNormalUse: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: xl_3.src,
                        alt: "",
                        objectFit: "cover",
                        layout: "fill"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultsStyledDefaultText, {
                children: "The coding efficiency of pulsar-avif is not much different from the software AVIF encoders."
            })
        ]
    });
};
/* harmony default export */ var Pulsar_AVIFDetailResults = (AVIFDetailResults);
var AVIFDetailResultsContainer = (0,styled_components_browser_esm/* default */.ZP)(AVIFDetailCommonContainer).withConfig({
    displayName: "AVIFDetailResults__AVIFDetailResultsContainer",
    componentId: "sc-50bf67a-0"
})(AVIFDetailResults_templateObject());
var ResultsStyledDefaultText = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* AVIFDefaultText */.oU).withConfig({
    displayName: "AVIFDetailResults__ResultsStyledDefaultText",
    componentId: "sc-50bf67a-1"
})(AVIFDetailResults_templateObject1());

;// CONCATENATED MODULE: ./components/Product/Pulsar/AVIFEncodingSpeed.tsx

function AVIFEncodingSpeed_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .kodak-w,\n  .clic-w,\n  .hwd-w {\n    margin-top: 24px;\n  }\n  .kodak-w table,\n  .clic-w table {\n    margin: 24px 0;\n  }\n  .kodak-w table td p,\n  .clic-w table td p {\n    min-height: 0;\n  }\n"
    ]);
    AVIFEncodingSpeed_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var AVIFEncodingSpeed = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AVIFEncodingSpeedContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFCommonComponents/* AVIFHeadTextComponent */._, {
                children: "Encoding Speed"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CodecDetailSubTitle, {
                children: "Hardware Platforms"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                    as: "th",
                                    children: "Encoder"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                    as: "th",
                                    children: "Microsoft Azure VM"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                    as: "th",
                                    children: "Specs."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "pulsar-avif"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "NP10",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://learn.microsoft.com/en-us/azure/virtual-machines/np-series",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFStrongText, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "under-l",
                                                            children: "NP-series - Azure Virtual Machines | Microsoft Learn"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "AMD Alveo U250 1ea + Intel(R) Xeon(R) Platinum 8171 CPU @ 2.6GHz, 10 cores"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "avifenc,",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "libjpeg-turbo"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "D32s",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://learn.microsoft.com/en-us/azure/virtual-machines/dv3-dsv3-series#dsv3-series",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFStrongText, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "under-l",
                                                            children: "Dv3 and Dsv3-series - Azure Virtual Machines | Microsoft Learn"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                        as: "td",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Intel(R) Xeon(R) Platinum 8370C CPU @ 2.8GHz, 32 cores"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "kodak-w",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CodecDetailSubTitle, {
                        children: "Kodak (24 images of 768x512)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                                as: "li",
                                children: "Encoding 24 images simultaneously (24 processes)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                                as: "li",
                                children: "Each software encoding process is executed with 4 threads. (-j 4)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        className: "t-f-th",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                            as: "th"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                            as: "th",
                                            children: "time [ms]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                            as: "th",
                                            children: "fps"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                            as: "th",
                                            children: "CPU utilization"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "pulsar-avif"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFStrongText, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "under-l",
                                                        children: "58.6"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFStrongText, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "under-l",
                                                            children: "409.85"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "305%"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "avifenc(aom)"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "405"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "59.26"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "3200%"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "avifenc(svt)"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "1325"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "18.11"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "3200%"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AVIFStrongText, {
                        as: "strong",
                        style: {
                            margin: "24px 0 24px"
                        },
                        children: [
                            "Note. When we tested pulsar-avif with 100 times of encoding 24 images, the average frame rate was increased to",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "under-l",
                                children: "582 fps."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "clic-w",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CodecDetailSubTitle, {
                        children: "CLIC (303 images of 2048x1320)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                                as: "li",
                                children: "avifienc(aom): encoding 32 images simultaneously with -j 8 to encode 303 images"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                                as: "li",
                                children: "avifenc(svt): encoding 16 images simultaneously with -j 4 to encode 303 images"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        className: "t-f-th",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                            as: "th"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                            as: "th",
                                            children: "time [ms]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                            as: "th",
                                            children: "fps"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeaderText, {
                                            as: "th",
                                            children: "CPU utilization"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "pulsar-avif"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFStrongText, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "under-l",
                                                            children: "3267"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AVIFStrongText, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "under-l",
                                                            children: "92.74"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "570%"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "avifenc(aom)"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "16191"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "18.71"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "3200%"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "avifenc(svt)"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "65826"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "4.60"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableText, {
                                                as: "td",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "3200%"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AVIFStrongText, {
                        as: "strong",
                        style: {
                            margin: "0 0 24px",
                            display: "inline-block"
                        },
                        children: [
                            "Note. When we tested pulsar-avif with 100 times of encoding 303 images, the average frame rate was increased to",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "under-l",
                                children: "93.5 fps."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                        children: "Note. For the evaluation of the performance of pulsar-avif, we developed and used a daemon where a queue is embedded. The CPU utilization reported above is mostly taken by the daemon and client processes waiting for allocation of AVIF encoding hardware resources. For example, the 305% utilization to encode 24 Kodak images in pulsar-avif consists of 65% from daemon and 240% from 24 client processes (10% per process)."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hwd-w",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CodecDetailSubTitle, {
                        children: "How we determined the number of threads for each process"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFDefaultText */.oU, {
                        children: "We picked up threads# where CPU utilization was not increased anymore, even if more threads were specified in the command line for encoding a single image."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Pulsar_AVIFEncodingSpeed = (AVIFEncodingSpeed);
var AVIFEncodingSpeedContainer = (0,styled_components_browser_esm/* default */.ZP)(AVIFDetailCommonContainer).withConfig({
    displayName: "AVIFEncodingSpeed__AVIFEncodingSpeedContainer",
    componentId: "sc-38107f28-0"
})(AVIFEncodingSpeed_templateObject());

;// CONCATENATED MODULE: ./components/Product/Pulsar/AVIFDetails.tsx

function AVIFDetails_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AVIFDetails_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var AVIFDetails = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AVIFDetailsContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulsar_AVIFDetailCodec, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulsar_AVIFDetailResults, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulsar_AVIFDetailExamples, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulsar_AVIFEncodingSpeed, {})
        ]
    });
};
/* harmony default export */ var Pulsar_AVIFDetails = (AVIFDetails);
var AVIFDetailsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AVIFDetails__AVIFDetailsContainer",
    componentId: "sc-92e8113e-0"
})(AVIFDetails_templateObject());

// EXTERNAL MODULE: ./components/Product/Pulsar/AvifSQTestCondition.tsx
var AvifSQTestCondition = __webpack_require__(1222);
// EXTERNAL MODULE: ../../packages/assets/icons.tsx
var icons = __webpack_require__(1089);
;// CONCATENATED MODULE: ./pages/avif-speed-quality-benchmark.tsx

function avif_speed_quality_benchmark_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  overflow-x: hidden;\n\n  & > .inner-container {\n    @media screen and (min-width: 1440px) {\n      width: 100%;\n      max-width: 1048px;\n      margin: 142px auto 202px;\n    }\n    @media screen and (min-width: 1240px) and (max-width: 1439px) {\n      width: calc(100% - 192px);\n      margin: 142px 96px 202px;\n    }\n    @media screen and (min-width: 905px) and (max-width: 1239px) {\n      width: calc(100% - 112px);\n      margin: 142px 56px 202px;\n    }\n    @media screen and (min-width: 600px) and (max-width: 904px) {\n      width: calc(100% - 64px);\n      margin: 142px 32px 202px;\n    }\n    @media screen and (max-width: 599px) {\n      width: calc(100% - 32px);\n      margin: 142px 16px 202px;\n    }\n  }\n  .title-a-s-q-b {\n    margin-top: 44px;\n    padding: 32px 0 24px;\n    text-align: center;\n    margin-bottom: 24px;\n    border-bottom: 1px solid #d4d4d4;\n  }\n  .nav-back-btn {\n    width: 96px;\n    height: 96px;\n    background: #d9d9d9;\n    border-radius: 50%;\n    transform: rotate(-90deg);\n  }\n"
    ]);
    avif_speed_quality_benchmark_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var metaObj = {
    description: "AVIF Speed / Quality Benchmark"
};
var AVIFSpeedQualityBenchmarkPage = function() {
    var push = (0,router.useRouter)().push;
    (0,useRemoveScrollTop/* useRemoveScrollTop */.W)();
    var handleNavigateBack = function() {
        return push("/product/avif/#product-section");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AVIFSpeedQualityBenchmarkPageContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "AVIF Speed/Quality Test Condition - BLUEDOT"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaObj.description
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaObj.description
                    }, "og:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:description",
                        content: metaObj.description
                    }, "twitter:description")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeader/* default */.Z, {
                isScrolled: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSpaceWrapper/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "inner-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "nav-back-btn",
                        onClick: handleNavigateBack,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ChevronVerticalIcon */.Q8, {
                            color: "#1C1B1F",
                            width: "20",
                            height: "20"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* AVIFHeadText */.cf, {
                        className: "title-a-s-q-b",
                        as: "div",
                        children: "AVIF Speed/Quality Test Condition"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvifSQTestCondition/* AVIFSpeedQualityImgs */.g, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulsar_AVIFDetails, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(About/* AboutCheckoutProduct */.yz, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var avif_speed_quality_benchmark = (AVIFSpeedQualityBenchmarkPage);
var AVIFSpeedQualityBenchmarkPageContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "avif-speed-quality-benchmark__AVIFSpeedQualityBenchmarkPageContainer",
    componentId: "sc-a8121ac3-0"
})(avif_speed_quality_benchmark_templateObject());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [779,965,572,833,710,774,888,179], function() { return __webpack_exec__(110); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);